import { render } from "./ColorText.vue?vue&type=template&id=7d27077a&scoped=true"
import script from "./ColorText.vue?vue&type=script&lang=js"
export * from "./ColorText.vue?vue&type=script&lang=js"

import "./ColorText.vue?vue&type=style&index=0&id=7d27077a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d27077a"]])

export default __exports__